const numberCeil = (number) => Math.ceil(number)

export { numberCeil }
